import { render, staticRenderFns } from "./ExpireTitle.vue?vue&type=template&id=24c275f0&scoped=true&"
import script from "./ExpireTitle.vue?vue&type=script&lang=js&"
export * from "./ExpireTitle.vue?vue&type=script&lang=js&"
import style0 from "./ExpireTitle.vue?vue&type=style&index=0&id=24c275f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c275f0",
  null
  
)

export default component.exports